/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trialactivated1Inputs */

const en_trialactivated1 = /** @type {(inputs: Trialactivated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial activated successfully.`)
};

const de_trialactivated1 = /** @type {(inputs: Trialactivated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testabo aktiviert.`)
};

/**
* | output |
* | --- |
* | "Trial activated successfully." |
*
* @param {Trialactivated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const trialactivated1 = /** @type {((inputs?: Trialactivated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trialactivated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trialactivated1(inputs)
	return de_trialactivated1(inputs)
});
export { trialactivated1 as "trialActivated" }